import React from "react";
import { Button, Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
// import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
// import Switch from "@mui/material/Switch";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import FormGroup from "@mui/material/FormGroup";
// End

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// const label = { inputProps: { "aria-label": "Size switch demo" } };

// For Modal
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import CloseIcon from "@mui/icons-material/Close";
// End

function ResidentReportNewList() {
  // const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // End

  // For Modal
  const [open2, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  // const handleClickOpen2 = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose2 = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open2]);
  // End

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  return (
    <>
      <Grid container spacing={3} className="mainHeadingLine">
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut">
              <div className="visitorHead">All Residents</div>
              <div className="visitorListNewInner">
                <div className="visitorSearch">
                  <div className="visitorSearchDiv">
                    <SearchIcon className="visitorSearchIco" />
                    <input type="text" placeholder="Search" />
                    <MicIcon className="visitorMicIco" />
                  </div>
                  <SortIcon
                    className="visitorFilterIco"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  />
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={handleClose}>Filter Item 1</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 2</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 3</MenuItem>
                  </Menu>
                </div>

                <div className="visitContDiv">
                  <div className="visitCont1 resideNewContOut">
                    <div className="visitContProf">
                      <Zoom>
                        <img src="https://live-production.wcms.abc-cdn.net.au/05861674eec209e9e4b845e31f477dec?impolicy=wcms_crop_resize&cropH=2203&cropW=2203&xPos=0&yPos=0&width=862&height=862" alt="altimg"/>
                      </Zoom>
                    </div>
                    <div className="visitContLeft">
                      <h3 className="visitContHed">Jerome Bell</h3>
                      <p className="visitContMob">(704) 555-0127</p>
                      <p className="visitContTime">sara.cruz@example.com</p>
                    </div>
                    <div className="visitBottCont">
                      <p>Flat Number</p>
                      <b>Wing A-922</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Designation</p>
                      <b>Scretory</b>
                    </div>
                    <div className="resideNewCont">
                      <CreateIcon className="editBt" />
                      <DeleteIcon className="deleteBt" />
                    </div>
                  </div>
                </div>
                <div className="visitContDiv">
                  <div className="visitCont1 resideNewContOut">
                    <div className="visitContProf">
                      <Zoom>
                        <img src="https://live-production.wcms.abc-cdn.net.au/05861674eec209e9e4b845e31f477dec?impolicy=wcms_crop_resize&cropH=2203&cropW=2203&xPos=0&yPos=0&width=862&height=862" alt="altimg"/>
                      </Zoom>
                    </div>
                    <div className="visitContLeft">
                      <h3 className="visitContHed">Jerome Bell</h3>
                      <p className="visitContMob">(704) 555-0127</p>
                      <p className="visitContTime">sara.cruz@example.com</p>
                    </div>
                    <div className="visitBottCont">
                      <p>Flat Number</p>
                      <b>Wing A-922</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Designation</p>
                      <b>Scretory</b>
                    </div>
                    <div className="resideNewCont">
                      <CreateIcon className="editBt" />
                      <DeleteIcon className="deleteBt" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Entry Pass Preview</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="entryPassMain">
                      <div className="entryPassInner">
                        <div className="entryPassTop">
                          <h4>Park Side Apartment</h4>
                          <Button>Security Guard</Button>
                          <div className="entryPassProMain">
                            <div className="entryPassPro">
                              <Zoom>
                                <img src="https://i.pinimg.com/474x/7f/9d/93/7f9d93408e934aced0f2409656bca021.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <p>Devon Lane</p>
                            <span>(808) 555-0111</span>
                          </div>
                        </div>
                        <div className="entryPassBott">
                          <div className="emtyPssBarOut">
                            <Zoom>
                              <img src="https://www.freepnglogos.com/uploads/qr-code-png/qr-code-file-bangla-mobile-code-0.png" alt="altimg"/>
                            </Zoom>
                          </div>
                          <p>Powered by Resipro</p>
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={addCommitee}>
                        Download
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
                      <h4>Success !</h4>
                      <p>Successfully Downloaded</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default ResidentReportNewList;
